import { useEffect, useState, RefObject } from "react";

export function useScrollToBottomButton(scrollRef: RefObject<HTMLElement>) {
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const container = scrollRef.current;
    console.log("before");
    if (!container) return;
    console.log("after");
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;
      const isNearBottom = scrollHeight - scrollTop - clientHeight < 100;
      console.log("isNearBottom: ", isNearBottom);
      setShowScrollButton(!isNearBottom);
    };

    container.addEventListener("scroll", handleScroll);
    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [scrollRef]);

  const scrollToBottom = () => {
    const container = scrollRef.current;
    if (container) {
      container.scrollTo({
        top: container.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  return {
    showScrollButton,
    scrollToBottom,
  };
}
